'use strict';
import {Component, Input, Output, EventEmitter} from "@angular/core";
const composeNumberHtml = <string>require('text!./composeNumber.html');

export const stripCharacters = (units: string) => {
    let strippedNum = String(units.replace(/[^0-9.]/g, ''));
    strippedNum = String(strippedNum.match(/\d+(?:\.\d+)?/));
    if (strippedNum === 'undefined' || strippedNum === 'null' || (typeof(units) !== "string" && isNaN(units))) {
        return 0;
    }
    return parseFloat(strippedNum);
};

export const formatWithCommas = (units: number) => {
    if (units === undefined || units === null || (typeof(units) !== "string" && isNaN(units))) {
        return "0";
    } else {
      let n: string[];
      let stringifiedNum = String(units);
      if (stringifiedNum.indexOf(".") !== -1) {
          if (stringifiedNum[stringifiedNum.length - 1] !== "." && stringifiedNum[stringifiedNum.length - 1] !== "0") {
              stringifiedNum = String(parseFloat(parseFloat(stringifiedNum).toFixed(7)));
          }
          n = stringifiedNum.split(".");
          n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return n.join(".");
      } else {
          return stringifiedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
};

@Component({
    selector: 'compose-number',
    template: composeNumberHtml
})

export class ComposeNumberComponent {
    @Input() object: any;
    @Input() key: string;
    @Output() unitsChange = new EventEmitter();
    displayedUnits: string;

    ngOnInit() {
        const strippedNum = stripCharacters(String(this.object[this.key]));
        this.displayedUnits = formatWithCommas(strippedNum);
    }

    onKey(event: KeyboardEvent) {
        const strippedNum = stripCharacters((<HTMLInputElement>event.target).value);
        this.displayedUnits = formatWithCommas(strippedNum);
        this.object[this.key] = strippedNum;
        this.unitsChange.emit(this.object);
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/composeNumber.ts